import React from "react";
import IconButton from "@mui/material/IconButton";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import API from "../api/index";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Badge from "@mui/material/Badge";
import { Button, Box } from "@mui/material";

const StyledMenuItem = styled(MenuItem)({
  paddingBottom: 10,
  paddingTop: 10,
  borderRadius: 25,
});

const StyledTypography = styled(Typography)({
  fontSize: "0.9em",
});

const calculateBadgeContent = (notifications) => {
  const unreadNotifications = notifications.filter(
    (notification) => notification.letturaNotifiche === "NotRead"
  ).length;
  return unreadNotifications;
};

function NotifyMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifications, setNotifications] = useState([]);
  const open = Boolean(anchorEl);

  useEffect(() => {
    API.getNotification().then((response) => {
      setNotifications(response.data);
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const NotificationType3 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 3)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      ...notification,
      tE: 3,
    }));
  const NotificationType9 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 9)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      ...notification,
      tE: 9,
    }));
  const NotificationType8 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 8)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      ...notification,
      tE: 8,
    }));

  const [
    combinedNotification = [
      ...NotificationType3,
      ...NotificationType9,
      ...NotificationType8,
    ],
    setNotificationsState,
  ] = useState();

  combinedNotification.sort((a, b) => {
    const dateA = new Date(
      a.timeStamp.split(" ")[0].split("/").reverse().join("-") +
        " " +
        a.timeStamp.split(" ")[1]
    );
    const dateB = new Date(
      b.timeStamp.split(" ")[0].split("/").reverse().join("-") +
        " " +
        b.timeStamp.split(" ")[1]
    );
    return dateB - dateA;
  });

  const handleNotificationSign = (notificationId) => {
    const updatedNotificationState = combinedNotification.map((notif) => {
      if (
        notif._id === notificationId &&
        notif.letturaNotifiche === "NotRead"
      ) {
        API.updateNotify({ id: notificationId });
        return { ...notif, letturaNotifiche: "read" };
      }
      return notif;
    });
    setNotificationsState(updatedNotificationState);
  };
  const badgeContent = calculateBadgeContent(combinedNotification);

  const NotifyCard = combinedNotification.slice(0, 3).map((notification) => (
    <StyledMenuItem
      key={notification._id || `${notification.tE}-${notification.timeStamp}`}
      sx={{
        backgroundColor:
          notification.letturaNotifiche === "NotRead"
            ? "#4a4a4a"
            : notification.letturaNotifiche === "read"
            ? "#2a2a2a"
            : "",
        marginBottom: 2,
        marginLeft: 1,
        marginRight: 1,
      }}
      onClick={() => handleNotificationSign(notification._id)}
    >
      <div>
        <Typography sx={{ fontWeight: "bold" }}>
          Possible attack on {notification.matricola} :{" "}
        </Typography>
        <StyledTypography
          sx={{
            color:
              notification.tE === 9
                ? "yellow"
                : notification.tE === 3
                ? "orange"
                : notification.tE === 8
                ? "red"
                : "grey",
          }}
        >
          {notification.descrizione}
        </StyledTypography>
        <Typography>{notification.timeStamp}</Typography>
      </div>
    </StyledMenuItem>
  ));

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Badge badgeContent={badgeContent} color="secondary" size="small">
          <NotificationsOutlinedIcon />
        </Badge>
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          sx: {
            bgcolor: "#1E1E1E",
            display: "flex", // Aggiunto per utilizzare Flexbox
            flexDirection: "column", // Aggiunto per orientare i contenuti verticalmente
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, ml: 1 }}>
            Notifications :
          </Typography>
          <Button
            sx={{
              textTransform: 'none',
              backgroundColor: "transparent",
              color: "#D1C167",
              "&:hover": {
                backgroundColor: "transparent !important",
                color: "#131C2D",
              },
            }}
            style={{ fontWeight: "bold", fontSize: 15 }}
            onClick={() => {window.location.href='/user/notifications'}}
          >
            See All
          </Button>
        </Box>
        {NotifyCard}
      </Menu>
    </div>
  );
}

export default NotifyMenu;
